import PropTypes from "prop-types";
import { OutletFormDialog } from "../outlet-form-dialog";
import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";

import { Button } from "@mui/material";

export const AddOutletFormDialog = ({ onClose, onSubmitted }) => {
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async ({
    name,
    address,
    whatsapp,
    role,
    status,
    companyId,
    accountingActionChartOfAccounts,
    sellerBankAccounts,
  }) => {
    try {
      await apiClient.post("outlets", {
        name,
        address,
        whatsapp,
        role,
        status,
        companyId,
        accountingActionChartOfAccounts,
        ...(sellerBankAccounts !== undefined && { sellerBankAccounts }),
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan outlet"));

      throw error;
    }
  };

  return (
    <OutletFormDialog
      onClose={onClose}
      dialogTitle="Tambah Outlet"
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Tambah
        </Button>
      )}
    />
  );
};

AddOutletFormDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
};
